import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, XCircle, ShieldCheck, Lock, CreditCard, Star, ArrowRight, Gift, Clock, ChevronLeft, ChevronRight, Zap, Users, TrendingUp } from 'lucide-react';
const MetaPixel = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2020793225485829');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return null;
};
const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const buyers = [{
    name: 'María',
    city: 'Córdoba',
    time: 'hace 5 minutos',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&q=80'
  }, {
    name: 'Juan',
    city: 'Buenos Aires',
    time: 'hace 12 minutos',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80'
  }, {
    name: 'Lucía',
    city: 'Rosario',
    time: 'hace 25 minutos',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=100&q=80'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBuyer(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    }, 20000);
    return () => clearInterval(interval);
  }, [buyers.length]);
  if (!isVisible) return null;
  const buyer = buyers[currentBuyer];
  return <div className="fixed bottom-24 left-4 bg-white rounded-lg shadow-2xl p-3 flex items-center gap-3 z-50 animate-fade-in-up border-l-4 border-brand-green max-w-xs" data-id="element-0">
      <img src={buyer.img} alt={buyer.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1" />
      <div data-id="element-2">
        <p className="text-sm font-bold text-gray-800" data-id="element-3">
          {buyer.name} de {buyer.city}
        </p>
        <p className="text-xs text-gray-600" data-id="element-4">
          Acaba de comprar la guía digital
        </p>
        <p className="text-xs text-brand-blue font-semibold mt-1" data-id="element-5">
          {buyer.time}
        </p>
      </div>
    </div>;
};
const WhatsAppButton = () => <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3" data-id="element-6">
    <div className="bg-white text-gray-800 px-4 py-3 rounded-2xl shadow-xl border border-gray-200 text-sm font-bold animate-bounce-slow relative mb-2 hidden sm:block" data-id="element-7">
      ¿Tienes dudas? ¡Mandanos un WhatsApp!
      <div className="absolute -right-2 bottom-3 w-4 h-4 bg-white transform rotate-45 border-r border-b border-gray-200" data-id="element-8"></div>
    </div>
    <a href="https://wa.me/+5493813588908" target="_blank" rel="noopener noreferrer" className="bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center justify-center" data-id="element-9">
      <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor" data-id="element-10">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-11" />
      </svg>
    </a>
  </div>;
const customSmoothScroll = (targetId: string, duration: number) => {
  const target = document.getElementById(targetId);
  if (!target) return;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;
  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const ease = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
    window.scrollTo(0, startPosition + distance * ease);
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };
  requestAnimationFrame(animation);
};
const CTAButton = ({
  text,
  subtext,
  onClick
}: {
  text: string;
  subtext?: string;
  onClick?: (e: React.MouseEvent) => void;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else {
      e.preventDefault();
      customSmoothScroll('checkout-section', 800);
    }
  };
  return <button onClick={handleClick} className="w-full max-w-xl mx-auto block bg-brand-orange hover:bg-[#d47018] text-white font-black text-xl md:text-2xl py-4 px-6 rounded-xl shadow-[0_10px_20px_rgba(229,129,41,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast border-b-4 border-[#b85a10]" data-id="element-12">
      <div className="flex items-center justify-center gap-2" data-id="element-13">
        {text} <ArrowRight className="w-6 h-6" data-id="element-14" />
      </div>
      {subtext && <p className="text-sm md:text-base font-normal mt-1 opacity-90" data-id="element-15">
          {subtext}
        </p>}
    </button>;
};
const BonusCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const bonuses = [{
    title: '🎁 BONO 1',
    subtitle: 'Botiquín Natural en Casa',
    description: 'Todo lo que necesitás tener siempre a mano',
    oldPrice: '$12.000'
  }, {
    title: '🎁 BONO 2',
    subtitle: 'Plan de 7 Días para Empezar',
    description: 'Un paso a paso simple para sentir cambios desde la primera semana',
    oldPrice: '$9.000'
  }, {
    title: '🎁 BONO 3',
    subtitle: 'Guía Rápida por Síntomas',
    description: 'Encontrá la solución en segundos',
    oldPrice: '$10.000'
  }];
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % bonuses.length);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + bonuses.length) % bonuses.length);
  return <div className="relative max-w-md mx-auto" data-id="element-16">
      <div className="overflow-hidden" data-id="element-17">
        <div className="flex transition-transform duration-500 ease-out" style={{
        transform: `translateX(-${currentSlide * 100}%)`
      }} data-id="element-18">
          {bonuses.map((bonus, index) => <div key={index} className="w-full flex-shrink-0 px-2" data-id="element-19">
              <div className="bg-white text-gray-900 rounded-2xl p-6 shadow-xl border-4 border-brand-green" data-id="element-20">
                <h3 className="text-xl font-black mb-1 text-brand-blue text-center" data-id="element-21">
                  {bonus.title}
                </h3>
                <h4 className="text-lg font-bold mb-2 text-gray-800 text-center" data-id="element-22">
                  {bonus.subtitle}
                </h4>
                <p className="text-sm text-gray-600 mb-4 text-center" data-id="element-23">
                  {bonus.description}
                </p>
                <div className="text-center" data-id="element-24">
                  <div className="text-base font-bold" data-id="element-25">
                    <span className="line-through text-red-500" data-id="element-26">
                      {bonus.oldPrice}
                    </span>
                    <span className="text-brand-green text-2xl ml-2" data-id="element-27">
                      → GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-1.5 rounded-full shadow-lg z-10" data-id="element-28">
        <ChevronLeft className="w-5 h-5 text-brand-blue" data-id="element-29" />
      </button>
      <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-1.5 rounded-full shadow-lg z-10" data-id="element-30">
        <ChevronRight className="w-5 h-5 text-brand-blue" data-id="element-31" />
      </button>

      <div className="flex justify-center gap-2 mt-4" data-id="element-32">
        {bonuses.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-brand-green w-6' : 'bg-gray-300'}`} data-id="element-33" />)}
      </div>
    </div>;
};
export function App() {
  const newTestimonials = [{
    name: 'Mariana',
    age: 34,
    quote: 'Desde que empecé a usar las recetas del módulo de digestión, me siento mucho más liviana. ¡Chau acidez!',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Carlos',
    age: 42,
    quote: 'Mi hijo siempre se resfriaba en invierno. Con el jarabe natural del módulo 3, este año invicto.',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Julieta',
    age: 28,
    quote: 'No creía mucho en esto, pero el té para el dolor de cabeza me salvó la vida en la oficina.',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Martín',
    age: 39,
    quote: 'Excelente inversión. Los ingredientes son cosas que ya compraba en el súper, pero no sabía cómo combinarlos.',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Valeria',
    age: 31,
    quote: 'El plan de 7 días me dio muchísima energía. Dejé el café y me siento mejor que nunca.',
    img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Roberto',
    age: 55,
    quote: 'Muy bien explicado, sin palabras raras. Fui directo a la receta para el dolor articular y me alivió un montón.',
    img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Silvia',
    age: 47,
    quote: 'Lo mejor es la guía rápida por síntomas. Cuando me duele algo, busco ahí y en 5 minutos tengo la solución.',
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Lucas',
    age: 26,
    quote: 'Me encanta que sea 100% natural. Ya no me intoxico con tanto ibuprofeno.',
    img: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=150&q=80'
  }];
  return <div className="font-sans text-gray-800 bg-gray-50 selection:bg-brand-green selection:text-white" data-id="element-34">
      <MetaPixel data-id="element-35" />
      <SalesPopup data-id="element-36" />
      <WhatsAppButton data-id="element-37" />

      {/* HERO SECTION */}
      <section className="relative pt-8 pb-8 px-4 border-b-8 border-brand-green overflow-hidden" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/6eZ4qL65ezJZjjvwPWUFUr/1.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-38">
        <div className="absolute inset-0 bg-white/85 backdrop-blur-sm" data-id="element-39"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-40">
          <h1 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-4 tracking-tight drop-shadow-lg" data-id="element-41">
            <span className="text-brand-green" data-id="element-42">🌿 500 RECETAS</span> DE REMEDIOS
            NATURALES
          </h1>

          <div className="relative max-w-sm mx-auto mb-4 rounded-2xl overflow-hidden shadow-2xl border-4 border-brand-green bg-white" data-id="element-43">
            <img src="https://cdn.magicpatterns.com/uploads/b1GtLzZUedbrqFiUfrnRf5/2.png" alt="500 Recetas de Remedios Naturales" className="w-full h-auto object-cover" data-id="element-44" />
          </div>

          <h2 className="text-lg md:text-xl font-medium text-gray-900 mb-4 max-w-3xl mx-auto leading-relaxed bg-white/60 backdrop-blur-sm p-3 rounded-xl" data-id="element-45">
            Mejora tu sistema inmunologico, alivia sintomas, dolores, mejora tus
            habitos alimenticios resueltos en un solo lugar. Guía práctica lista
            para usar — sin químicos, sin improvisar, sin depender de pastillas.
          </h2>

          <p className="text-xl font-bold text-brand-blue italic mb-4 bg-blue-50/90 backdrop-blur-sm py-3 px-4 rounded-xl inline-block" data-id="element-46">
            "Sabés qué hacer. Sabés qué tomar. Sabés cómo cuidarte."
          </p>

          <p className="text-base text-gray-900 mb-6 max-w-2xl mx-auto bg-white/60 backdrop-blur-sm p-3 rounded-xl" data-id="element-47">
            Guia completa para cuidar tu salud con remedios naturales, usando
            ingredientes que todo el mundo tiene en casa.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-6 text-xs md:text-sm font-bold text-gray-900" data-id="element-48">
            <span className="flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm" data-id="element-49">
              <Lock className="w-3 h-3 text-brand-green" data-id="element-50" /> 📄 PDF
            </span>
            <span className="flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm" data-id="element-51">
              <Lock className="w-3 h-3 text-brand-green" data-id="element-52" /> ⚡ Acceso inmediato
            </span>
            <span className="flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm" data-id="element-53">
              <Lock className="w-3 h-3 text-brand-green" data-id="element-54" /> 🌿 100% natural
            </span>
            <span className="flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm" data-id="element-55">
              <Lock className="w-3 h-3 text-brand-green" data-id="element-56" /> 🏡 Para toda la
              familia
            </span>
          </div>

          <CTAButton text="💚 QUIERO MI GUÍA AHORA" subtext="Oferta especial disponible hoy" data-id="element-57" />

          <div className="flex flex-wrap justify-center items-center gap-4 mt-4 text-xs md:text-sm text-gray-900 font-medium bg-white/60 backdrop-blur-sm p-2 rounded-xl inline-flex" data-id="element-58">
            <span className="flex items-center gap-1" data-id="element-59">
              <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-60" /> Garantía 7
              días
            </span>
            <span className="flex items-center gap-1" data-id="element-61">
              <Lock className="w-4 h-4 text-brand-blue" data-id="element-62" /> Pago protegido por
              Mercado Pago
            </span>
            <span className="flex items-center gap-1" data-id="element-63">
              <CreditCard className="w-4 h-4 text-gray-600" data-id="element-64" /> Mercado Pago |
              Tarjeta | Transferencia
            </span>
          </div>
        </div>
      </section>

      {/* INITIAL TESTIMONIALS */}
      <section className="py-6 bg-gray-50 px-4" data-id="element-65">
        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-4" data-id="element-66">
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-67">
            <div className="flex text-brand-yellow mb-2" data-id="element-68">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-69" />)}
            </div>
            <p className="text-gray-700 text-sm italic mb-2" data-id="element-70">
              "Dejé de tomar pastillas para todo. Literalmente tiene solución
              para todos los síntomas que pueda llegar a tener, dolor de
              garganta, febrícula, molestia corporal, muy completo."
            </p>
            <p className="font-bold text-sm text-gray-900" data-id="element-71">
              — Laura M., Córdoba
            </p>
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-72">
            <div className="flex text-brand-yellow mb-2" data-id="element-73">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-74" />)}
            </div>
            <p className="text-gray-700 text-sm italic mb-2" data-id="element-75">
              "Lo mejor es que todo lo tengo en casa. Las explicaciones son muy
              sencillas."
            </p>
            <p className="font-bold text-sm text-gray-900" data-id="element-76">
              — Andrea P., Buenos Aires
            </p>
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-77">
            <div className="flex text-brand-yellow mb-2" data-id="element-78">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-79" />)}
            </div>
            <p className="text-gray-700 text-sm italic mb-2" data-id="element-80">
              "Me cambió la energía completamente. Ya no dependo del café para
              arrancar el día."
            </p>
            <p className="font-bold text-sm text-gray-900" data-id="element-81">
              — Sofía R., Rosario
            </p>
          </div>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-8 bg-black text-white px-4" data-id="element-82">
        <div className="max-w-3xl mx-auto" data-id="element-83">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-brand-pink" data-id="element-84">
            Si esto te pasa, seguí leyendo:
          </h2>

          <div className="space-y-3 mb-8 text-base md:text-lg" data-id="element-85">
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-86">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-87" />
              <p data-id="element-88">
                Vivís tomando pastillas que sabés que tarde o temprano te van a
                pasar factura
              </p>
            </div>
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-89">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-90" />
              <p data-id="element-91">Cada cambio de clima te enfermás como si fuera normal</p>
            </div>
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-92">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-93" />
              <p data-id="element-94">Cuando te duele algo, no sabés qué hacer</p>
            </div>
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-95">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-96" />
              <p data-id="element-97">Tomás gaseosa todos los días y vivís hinchada, sin energía</p>
            </div>
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-98">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-99" />
              <p data-id="element-100">Te sentís cansado todo el tiempo, aunque duermas</p>
            </div>
            <div className="flex items-start gap-3 bg-black/40 backdrop-blur-sm border-2 border-red-500 rounded-xl p-3" data-id="element-101">
              <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-102" />
              <p data-id="element-103">Dependés del café o el azúcar para arrancar el día</p>
            </div>
          </div>

          <div className="bg-gray-900 p-6 rounded-2xl border border-gray-800 text-center" data-id="element-104">
            <h3 className="text-xl font-bold mb-4 text-brand-yellow" data-id="element-105">
              La verdad es esta:
            </h3>
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-base font-medium" data-id="element-106">
              <span className="flex items-center gap-2" data-id="element-107">
                <XCircle className="w-4 h-4 text-red-500" data-id="element-108" /> Esto NO es normal
              </span>
              <span className="flex items-center gap-2" data-id="element-109">
                <XCircle className="w-4 h-4 text-red-500" data-id="element-110" /> Tu cuerpo no está
                fallando
              </span>
              <span className="flex items-center gap-2" data-id="element-111">
                <XCircle className="w-4 h-4 text-red-500" data-id="element-112" /> Nadie te enseñó
                otra forma
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-10 bg-white px-4 text-center" data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-black text-brand-green mb-3" data-id="element-115">
            🌿 Existe una forma distinta
          </h2>
          <p className="text-xl font-medium text-gray-600 mb-6" data-id="element-116">
            Más simple. Más natural. Más inteligente.
          </p>

          <div className="bg-brand-green/10 border-4 border-brand-green rounded-2xl p-6 md:p-8 mb-8" data-id="element-117">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-3" data-id="element-118">
              💚 500 RECETAS DE REMEDIOS CASEROS
            </h3>
            <p className="text-lg text-gray-700" data-id="element-119">
              Una guía práctica, directa y fácil de usar para mejorar tu salud
              con ingredientes naturales.
            </p>
          </div>

          <CTAButton text="SÍ, QUIERO CAMBIAR MIS HÁBITOS" data-id="element-120" />
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-10 bg-gray-50 px-4" data-id="element-121">
        <div className="max-w-5xl mx-auto" data-id="element-122">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-2" data-id="element-123">
            Lo que recibís:
          </h2>
          <p className="text-lg text-center text-brand-green font-bold mb-6" data-id="element-124">
            🌿 LOS 6 MÓDULOS COMPLETOS
            <br data-id="element-125" />
            <span className="text-gray-600 font-normal text-sm" data-id="element-126">
              Para cuidar tu salud de forma natural, todos los días
            </span>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-127">
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-brand-green flex flex-col justify-center" data-id="element-128">
              <h4 className="text-sm font-bold mb-1" data-id="element-129">
                🟢 Módulo 1 — Fundamentos
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-130">
                Cómo funciona tu cuerpo · Cómo actúan los remedios caseros ·
                Base para no depender de químicos
              </p>
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-brand-yellow flex flex-col justify-center" data-id="element-131">
              <h4 className="text-sm font-bold mb-1" data-id="element-132">
                🟡 Módulo 2 — Ingredientes
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-133">
                Jengibre · Miel · Limón · Plantas medicinales · Qué usar, cuándo
                y para qué
              </p>
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-brand-orange flex flex-col justify-center" data-id="element-134">
              <h4 className="text-sm font-bold mb-1" data-id="element-135">
                🟠 Módulo 3 — Preparación
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-136">
                Infusiones · Jarabes · Mezclas naturales · Paso a paso simple
                para hacerlo en casa
              </p>
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-red-500 flex flex-col justify-center" data-id="element-137">
              <h4 className="text-sm font-bold mb-1" data-id="element-138">
                🔴 Módulo 4 — Por Síntomas
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-139">
                Gripe · Dolor de cabeza · Alergias · Digestión · Energía ·
                Soluciones listas para cada situación
              </p>
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-purple-500 flex flex-col justify-center" data-id="element-140">
              <h4 className="text-sm font-bold mb-1" data-id="element-141">
                🟣 Módulo 5 — Prevención
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-142">
                Hábitos naturales · Alimentos clave · Cómo fortalecer tu cuerpo
                y evitar enfermarte
              </p>
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border-l-4 border-gray-800 flex flex-col justify-center" data-id="element-143">
              <h4 className="text-sm font-bold mb-1" data-id="element-144">
                ⭐ Módulo 6 — Implementación
              </h4>
              <p className="text-xs text-gray-600 leading-tight" data-id="element-145">
                Cómo aplicar todo en tu día a día · Rutina simple · Sistema para
                sostener resultados
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm max-w-3xl mx-auto border border-gray-100" data-id="element-146">
            <h3 className="text-lg font-bold mb-3 text-center" data-id="element-147">
              Cada módulo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-2 text-sm" data-id="element-148">
              <div className="flex items-center gap-2" data-id="element-149">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-150" />{' '}
                <span data-id="element-151">Explicaciones simples y directas</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-152">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-153" />{' '}
                <span data-id="element-154">Aplicación práctica desde el primer día</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-155">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-156" />{' '}
                <span data-id="element-157">Soluciones con ingredientes accesibles</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-158">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-159" />{' '}
                <span data-id="element-160">Sistema “Abrir y Usar”</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-161">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-162" />{' '}
                <span data-id="element-163">Adaptado a la vida real (rápido y efectivo)</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-164">
                <CheckCircle2 className="w-4 h-4 text-brand-green shrink-0" data-id="element-165" />{' '}
                <span data-id="element-166">Enfoque natural, sin químicos</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-10 bg-brand-blue text-white px-4" data-id="element-167">
        <div className="max-w-5xl mx-auto" data-id="element-168">
          <div className="text-center mb-8" data-id="element-169">
            <Gift className="w-12 h-12 mx-auto mb-2 text-brand-yellow" data-id="element-170" />
            <h2 className="text-3xl md:text-4xl font-black mb-2" data-id="element-171">
              🎁 Además recibís 3 BONOS exclusivos
            </h2>
            <p className="text-lg font-bold text-brand-yellow bg-black/20 inline-block px-4 py-1 rounded-full" data-id="element-172">
              ¡GRATIS POR EL DÍA DE HOY!
            </p>
          </div>

          <BonusCarousel data-id="element-173" />

          <div className="text-center bg-black/20 p-4 rounded-xl max-w-xl mx-auto mt-8" data-id="element-174">
            <p className="text-xl font-black" data-id="element-175">
              🎁 Valor total bonos:{' '}
              <span className="line-through text-gray-300" data-id="element-176">$31.000</span> —{' '}
              <span className="text-brand-yellow" data-id="element-177">Incluidos sin costo</span>
            </p>
          </div>
        </div>
      </section>

      {/* CHECKOUT SECTION */}
      <section id="checkout-section" className="py-12 bg-gradient-to-b from-gray-900 to-black text-white px-4" data-id="element-178">
        <div className="max-w-4xl mx-auto" data-id="element-179">
          <div className="text-center mb-6" data-id="element-180">
            <div className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-2 rounded-full font-black text-lg mb-4 animate-pulse shadow-lg" data-id="element-181">
              <Clock className="w-5 h-5" data-id="element-182" /> ⏰ OFERTA TERMINA HOY
            </div>
            <p className="text-xl text-gray-300 font-bold mb-1" data-id="element-183">
              Esta es tu oportunidad
            </p>
            <p className="text-base text-gray-400" data-id="element-184">
              El precio sube mañana y no vuelve a bajar
            </p>
          </div>

          <div className="bg-gradient-to-br from-white to-gray-50 text-gray-900 rounded-2xl p-5 md:p-10 shadow-2xl border-4 md:border-8 border-brand-green relative overflow-hidden" data-id="element-185">
            <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 md:px-6 md:py-2 rounded-bl-2xl font-black text-sm md:text-base shadow-lg z-10" data-id="element-186">
              -75% HOY
            </div>

            <div className="text-center mt-6 mb-6" data-id="element-187">
              <h3 className="text-2xl md:text-4xl font-black text-brand-blue mb-1 leading-tight" data-id="element-188">
                500 RECETAS DE REMEDIOS NATURALES
              </h3>
              <p className="text-lg font-bold text-gray-700 mb-4" data-id="element-189">
                5 tomos + 3 bonos
              </p>

              <div className="flex justify-center gap-4 mb-4 flex-wrap" data-id="element-190">
                <div className="flex items-center gap-1 text-xs md:text-sm font-bold text-gray-700" data-id="element-191">
                  <Users className="w-4 h-4 text-brand-green" data-id="element-192" />
                  <span data-id="element-193">+2,847 personas ya lo tienen</span>
                </div>
                <div className="flex items-center gap-1 text-xs md:text-sm font-bold text-gray-700" data-id="element-194">
                  <TrendingUp className="w-4 h-4 text-brand-orange" data-id="element-195" />
                  <span data-id="element-196">Vendiendo rápido</span>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-brand-green/10 to-brand-blue/10 rounded-xl p-4 md:p-6 mb-6 border-2 border-brand-green/30" data-id="element-197">
              <div className="text-center mb-4" data-id="element-198">
                <p className="text-xs text-gray-600 font-bold mb-1" data-id="element-199">
                  PRECIO NORMAL
                </p>
                <p className="text-2xl text-gray-400 line-through font-bold mb-2" data-id="element-200">
                  $79.990
                </p>
                <p className="text-xs text-brand-orange font-black mb-1 flex items-center justify-center gap-1" data-id="element-201">
                  <Zap className="w-4 h-4" data-id="element-202" /> PRECIO ESPECIAL DE LANZAMIENTO
                </p>
                <p className="text-5xl md:text-7xl font-black text-brand-green mb-1" data-id="element-203">
                  $19.990
                </p>
                <p className="text-xs text-gray-600" data-id="element-204">
                  Pago único · Sin suscripciones · Tuyo para siempre
                </p>
              </div>

              <div className="grid grid-cols-3 gap-2 mt-4 text-xs md:text-sm" data-id="element-205">
                <div className="bg-white rounded-lg p-2 text-center shadow-sm" data-id="element-206">
                  <CheckCircle2 className="w-6 h-6 text-brand-green mx-auto mb-1" data-id="element-207" />
                  <p className="font-bold leading-tight" data-id="element-208">500+ Recetas</p>
                </div>
                <div className="bg-white rounded-lg p-2 text-center shadow-sm" data-id="element-209">
                  <CheckCircle2 className="w-6 h-6 text-brand-green mx-auto mb-1" data-id="element-210" />
                  <p className="font-bold leading-tight" data-id="element-211">6 Módulos</p>
                </div>
                <div className="bg-white rounded-lg p-2 text-center shadow-sm" data-id="element-212">
                  <CheckCircle2 className="w-6 h-6 text-brand-green mx-auto mb-1" data-id="element-213" />
                  <p className="font-bold leading-tight" data-id="element-214">3 Bonos Gratis</p>
                </div>
              </div>
            </div>

            <a href="https://checkout.ecompradigital.online/cart/46153566257340:1" className="w-full block text-center bg-gradient-to-r from-brand-orange to-red-600 hover:from-red-600 hover:to-brand-orange text-white font-black text-xl md:text-2xl py-4 px-6 rounded-xl shadow-[0_10px_30px_rgba(229,129,41,0.5)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast border-b-4 border-red-800 mb-4" data-id="element-215">
              🔥 SÍ, QUIERO ACCESO INMEDIATO
            </a>

            <div className="flex flex-wrap justify-center gap-3 text-xs md:text-sm text-gray-700 font-bold mb-4" data-id="element-216">
              <div className="flex items-center gap-1 bg-green-50 px-2 py-1.5 rounded-lg" data-id="element-217">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-218" /> Pago seguro
              </div>
              <div className="flex items-center gap-1 bg-blue-50 px-2 py-1.5 rounded-lg" data-id="element-219">
                <Zap className="w-4 h-4 text-brand-blue" data-id="element-220" /> Acceso instantáneo
              </div>
              <div className="flex items-center gap-1 bg-orange-50 px-2 py-1.5 rounded-lg" data-id="element-221">
                <ShieldCheck className="w-4 h-4 text-brand-orange" data-id="element-222" /> Garantía 7
                días
              </div>
            </div>

            <div className="text-center text-[10px] md:text-xs text-gray-500" data-id="element-223">
              <p className="mb-1" data-id="element-224">
                🔒 Tus datos están protegidos con encriptación SSL de 256 bits
              </p>
              <p data-id="element-225">
                Procesado por Mercado Pago · Aceptamos todas las tarjetas y
                transferencias
              </p>
            </div>
          </div>

          <div className="mt-8 bg-gradient-to-r from-gray-800 to-gray-900 rounded-xl p-6 border-2 border-brand-green text-center shadow-2xl" data-id="element-226">
            <ShieldCheck className="w-12 h-12 text-brand-green mx-auto mb-3" data-id="element-227" />
            <h4 className="text-2xl font-black mb-2 text-brand-yellow" data-id="element-228">
              🛡️ Garantía 100% sin riesgo
            </h4>
            <p className="text-base text-gray-300 mb-1" data-id="element-229">
              Probás la guía durante 7 días completos.
            </p>
            <p className="text-base text-gray-300 mb-2" data-id="element-230">
              Si no te gusta o no te sirve:
            </p>
            <p className="text-xl font-black text-brand-green mb-2" data-id="element-231">
              Te devolvemos cada peso invertido.
            </p>
            <p className="text-sm text-gray-400" data-id="element-232">
              Sin preguntas. Sin excusas. Sin vueltas.
            </p>
          </div>
        </div>
      </section>

      {/* EXTENDED TESTIMONIALS (MOVED BELOW CHECKOUT) */}
      <section className="py-12 bg-white px-4" data-id="element-233">
        <div className="max-w-6xl mx-auto" data-id="element-234">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-235">
            Lo que dicen quienes ya tienen su guía:
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-236">
            {newTestimonials.map((t, i) => <div key={i} className="bg-gray-50 p-4 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-237">
                <div className="flex items-center gap-3 mb-3" data-id="element-238">
                  <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-green" data-id="element-239" />
                  <div data-id="element-240">
                    <p className="font-bold text-sm text-gray-900" data-id="element-241">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-242">{t.age} años</p>
                    <div className="flex text-brand-yellow mt-0.5" data-id="element-243">
                      {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 fill-current" data-id="element-244" />)}
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 text-xs italic" data-id="element-245">"{t.quote}"</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-10 bg-gray-50 px-4" data-id="element-246">
        <div className="max-w-3xl mx-auto" data-id="element-247">
          <h2 className="text-2xl font-black text-center mb-6" data-id="element-248">
            ❓ Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-249">
            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-250">
              <h4 className="text-base font-bold text-gray-900 mb-1" data-id="element-251">
                ¿Necesito experiencia previa?
              </h4>
              <p className="text-sm text-gray-700" data-id="element-252">
                No. Está hecho para cualquier persona.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-253">
              <h4 className="text-base font-bold text-gray-900 mb-1" data-id="element-254">
                ¿Los ingredientes son fáciles de conseguir?
              </h4>
              <p className="text-sm text-gray-700" data-id="element-255">
                Sí. La mayoría ya los tenés en casa.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-256">
              <h4 className="text-base font-bold text-gray-900 mb-1" data-id="element-257">
                ¿Funciona para toda la familia?
              </h4>
              <p className="text-sm text-gray-700" data-id="element-258">
                Sí, son soluciones naturales de uso cotidiano.
              </p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-259">
              <h4 className="text-base font-bold text-gray-900 mb-1" data-id="element-260">
                ¿Cómo lo recibo?
              </h4>
              <p className="text-sm text-gray-700" data-id="element-261">
                Descarga inmediata después del pago.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-12 bg-brand-green text-white px-4 text-center" data-id="element-262">
        <div className="max-w-3xl mx-auto" data-id="element-263">
          <h2 className="text-3xl font-black mb-4" data-id="element-264">🌿 Decisión simple</h2>
          <p className="text-lg mb-2" data-id="element-265">
            Podés seguir dependiendo de pastillas para todo.
          </p>
          <p className="text-xl font-bold mb-8" data-id="element-266">
            O podés empezar a entender tu cuerpo y cuidarte de forma natural.
          </p>

          <div className="bg-white/10 p-6 rounded-xl mb-8" data-id="element-267">
            <h3 className="text-2xl font-black text-brand-yellow mb-1" data-id="element-268">
              💚 Tu cuerpo sabe sanar
            </h3>
            <p className="text-lg" data-id="element-269">Solo tenés que darle lo correcto.</p>
          </div>

          <CTAButton text="👉 EMPEZÁ HOY" data-id="element-270" />
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-6 text-center text-xs" data-id="element-271">
        <p data-id="element-272">
          © {new Date().getFullYear()} 500 Recetas de Remedios Naturales. Todos
          los derechos reservados.
        </p>
        <p className="mt-1 max-w-2xl mx-auto px-4" data-id="element-273">
          Este producto no sustituye el consejo médico profesional. Consulte
          siempre a su médico antes de comenzar cualquier tratamiento.
        </p>
      </footer>
    </div>;
}